import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

/**
 * Nord Account sign-up, reached from either invite route.
 *
 * This is the account boundary the whole privacy argument rests on: the member
 * creates their own login here, before the NordVPN app is ever opened. The
 * manager pays for the seat and never holds the credentials.
 */
export function NordAccountSignup({ v }: { v: Vals }) {
  return (
    <div
      style={sx(
        'position:absolute;inset:0;padding-top:56px;display:flex;flex-direction:column;background:#0b0b0f'
      )}
    >
      <div style={sx('flex:1;min-height:0;overflow:auto;padding:20px 20px 24px;display:flex;flex-direction:column')}>
        <div
          style={sx(
            'border-radius:var(--radius-lg);background:#14141b;border:1px solid rgba(255,255,255,.07);' +
              'padding:24px 20px;display:flex;flex-direction:column;align-items:center;gap:16px'
          )}
        >
          <span style={sx('display:flex;align-items:center;gap:8px')}>
            <span
              style={sx(
                'width:26px;height:26px;background:#b9bcc4;' +
                  '-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;' +
                  'mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat'
              )}
            />
            <span style={sx('font-size:var(--fs-lg);font-weight:var(--fw-bold);color:#fff')}>
              Nord
              <span style={sx('font-weight:var(--fw-normal);color:rgba(255,255,255,.6)')}>
                {' Account'}
              </span>
            </span>
          </span>

          <span
            style={sx(
              'font-size:var(--fs-4xl);font-weight:var(--fw-bold);color:#fff;' +
                'letter-spacing:var(--ls-sm);text-align:center;margin-top:4px'
            )}
          >
            Create an account
          </span>
          <span style={sx('font-size:var(--fs-xs);color:rgba(255,255,255,.6)')}>
            Already have an account?{' '}
            <span style={sx('color:#6b90fa;font-weight:var(--fw-medium)')}>Log in</span>
          </span>

          <SocialButton label="Sign up with Google" onClick={v.kOpenSignup}>
            <span
              style={sx(
                'width:20px;height:20px;flex:none;border-radius:var(--radius-full);background:#fff;' +
                  'display:flex;align-items:center;justify-content:center;' +
                  'font-size:13px;font-weight:700;color:#4285f4;font-family:var(--font-sans)'
              )}
            >
              G
            </span>
          </SocialButton>

          <SocialButton label="Sign up with Apple" onClick={v.kOpenSignup}>
            <span
              style={sx(
                'width:18px;height:18px;flex:none;background:#fff;' +
                  '-webkit-mask:url(/assets/icons/apple.svg) center/contain no-repeat;' +
                  'mask:url(/assets/icons/apple.svg) center/contain no-repeat'
              )}
            />
          </SocialButton>

          <span style={sx('display:flex;align-items:center;gap:10px;width:100%;margin:2px 0')}>
            <span style={sx('flex:1;height:1px;background:rgba(255,255,255,.12)')} />
            <span style={sx('font-size:var(--fs-2xs);color:rgba(255,255,255,.5)')}>
              Or continue with
            </span>
            <span style={sx('flex:1;height:1px;background:rgba(255,255,255,.12)')} />
          </span>

          <span
            style={sx(
              'width:100%;height:46px;border-radius:var(--radius-md);' +
                'border:1px solid rgba(255,255,255,.16);display:flex;align-items:center;' +
                'padding:0 14px;font-size:var(--fs-sm);color:#fff'
            )}
          >
            {v.memberEmailAddress}
          </span>

          <Hov
            as="button"
            onClick={v.kCreateAccount}
            style={sx(
              'width:100%;height:48px;border-radius:var(--radius-full);border:none;' +
                'background:var(--bg-accent);color:#fff;font-family:inherit;' +
                'font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer'
            )}
            hoverStyle={sx('background:var(--bg-accent-active)')}
          >
            Continue
          </Hov>

          <span
            style={sx(
              'font-size:var(--fs-2xs);line-height:16px;color:rgba(255,255,255,.45);text-align:center'
            )}
          >
            By signing up, you agree with our terms of service and privacy policy.
          </span>
        </div>
      </div>
    </div>
  )
}

function SocialButton({
  label,
  onClick,
  children,
}: {
  label: string
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <Hov
      as="button"
      onClick={onClick}
      style={sx(
        'width:100%;height:46px;border-radius:var(--radius-full);' +
          'border:1px solid rgba(255,255,255,.18);background:transparent;color:#fff;' +
          'font-family:inherit;font-size:var(--fs-sm);cursor:pointer;' +
          'display:flex;align-items:center;justify-content:center;gap:10px'
      )}
      hoverStyle={sx('background:rgba(255,255,255,.06)')}
    >
      {children}
      {label}
    </Hov>
  )
}
